import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import React from "react";
import { Doughnut } from "react-chartjs-2";

const StatusWiseSummaryComponent = ({ data }) => {
  return (
    <>
      {/* Status-wise Count (Pie Chart) */}
      <Card
        sx={{
          height: "100%",
        }}
      >
        <CardContent sx={{ padding: "8px" }}>
          <Typography variant="h6" color="primary" align="center">
            Status-wise Summary
          </Typography>
          <Box
            sx={{
              height: "200px",
              width: "100%",
              placeItems: "center",
              marginTop: 2
            }}
          >
            <Doughnut
              data={{
                labels: ["Open", "Closed", "Total"],
                datasets: [
                  {
                    data: [
                      (data?.summary?.status_wise_count?.Open || data?.summary?.status_wise_count?.open || 0),
                      (data?.summary?.status_wise_count?.Closed || data?.summary?.status_wise_count?.closed || 0),
                      data?.summary?.total_remarks || 0,
                    ],
                    backgroundColor: ["#42a5f5", "#66bb6a", "#ef5350"],
                  },
                ],
              }}
              options={{
                plugins: {
                  legend: {
                    display: true,
                    position: "bottom",
                  },
                  datalabels: {
                    color: "#000", // Set the color of data labels
                    font: {
                      size: 14,
                      weight: "bold",
                    },
                    formatter: (value) => value, // Display the value
                    anchor: "center",
                    align: "center",
                  },
                },
              }}
            />
          </Box>
          {!data?.summary?.status_wise_count && (
            <Typography
              variant="body2"
              color="textSecondary"
              align="center"
              sx={{ marginTop: 2 }}
            >
              No data available for the status-wise summary.
            </Typography>
          )}
        </CardContent>
      </Card>
    </>
  );
};

export default StatusWiseSummaryComponent;
